<template>
    <div class="clearfix">
        <a-upload 
            name="file" 
            :accept="accept"
            :multiple="multiple" 
            list-type="picture-card"
            :file-list="fileList"
            action="'http://192.168.1.63:9000/data/"
            :headers="headers" 
            
            :data="handleImportFile"
            @preview="handlePreview"
            @change="handleChange">

            <div v-if="fileList.length < maxFileCount">
                <a-icon type="plus" />
                <div class="ant-upload-text">
                    {{btnName}}
                </div>
            </div>
        </a-upload>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
    </div>
</template>

<script>
function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
export default {
    props:{
        btnName:{
            type:String,
            default:'导入'
        },
        maxFileCount:{
            type:Number,
            default:1
        },
        accept:{
            type:String,
            default:'.jpg, .jpeg, .png,.gif'
        },
        multiple:{
            type:Boolean,
            default:false,
        },
        picList:{
            type:Array,
            default:() => { return [] }
        }
    },

    data(){
        return {
            previewVisible:false,
            fileList:[],
            previewImage: '',
            headers: {
                authorization: 'authorization-text',
            },
        }
    },
    methods:{
        handleCancel() {
            this.previewVisible = false;
        },
        async handlePreview(file) {
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        handleImportFile(file){
            console.log('import');
            let result = this.D.syncSelect({
                type:'home/postobjectpolicyforFP',
                sync:true,
                params:{}
            })
            if (result.success !== '1') {
                // that.message.error(result['errorMsg']);
                return false;
            }
            const data = result.data;
            const {
                dir,
                policy,
                accessid,
                callback,
                signature
            } = data;
            const token = {
                policy: policy,
                OSSAccessKeyId: accessid,
                success_action_status: '200',
                callback: callback,
                signature: signature
            };
            const objName = dir + this.G.getUniqueCode() + this.G.getSuffix(file.name);
            file.objName = objName;
            return{
                ...token,
                key: objName
            }

        },
        //上传文件结果处理
        handleChange({fileList }) {
            this.fileList = fileList;
            let resultFiles = [];
            fileList.forEach(element => {
                if (element.status === 'done') {
                    resultFiles.push(element.objName)
                }
            });
            if(resultFiles.length > 0){
                this.$emit('handleFileChange',resultFiles)
            }
        },
    },
    watch:{
        'picList'(newVal){
            if(newVal){
                this.fileList = newVal
            }
        }
    }
}
</script>

<style scoped>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
